import { Box, Container, Grid, Typography } from "@mui/material";
import * as React from "react";

const AccessDeniedPage = () => {
  return (
    <Container>
      <Grid container justifyContent="center" alignItems="center" style={{ minHeight: "80vh" }}>
        <Grid item xs={12} md={6}>
          <Box p={2} boxShadow={3} borderRadius={2} textAlign="center" bgcolor="background.paper">
            <Typography variant="h4" gutterBottom color={"red"}>
              Elion Platform - access denied
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};
export default AccessDeniedPage;
